import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import NumberFormatter from '../modules/NumberFormatter';

export interface ReportHeaderProps {
  custA: number;
  custS: number;
  custR: number;
  deviceType: string;
}
// eslint-disable-next-line
const ReportHeader: React.FunctionComponent<ReportHeaderProps> = ({ deviceType, custA, custS, custR }: ReportHeaderProps): JSX.Element => (
    <div className={`report-header device-${deviceType}`}>
      <div className={'report-info-box'} style={{ backgroundColor: '#0FA3D9' }}>
        <span className={'icon'}>
          <FontAwesomeIcon icon={['fas', 'exclamation-triangle']} color={'white'}/>
        </span>
        <span className={'label'}>Total Customers Affected</span>
        <span className={'value'}><NumberFormatter>{custA}</NumberFormatter></span>
      </div>
      <div className={'report-info-box'} style={{ backgroundColor: '#737373' }}>
        <span className={'icon'}>
          <FontAwesomeIcon icon={['fas', 'user']} color={'white'}/>
        </span>
        <span className={'label'}>Total Customers Served</span>
        <span className={'value'}><NumberFormatter>{custS}</NumberFormatter></span>
      </div>
      <div className={'report-info-box'} style={{ backgroundColor: '#0058a4' }}>
        <span className={'icon'}>
          <FontAwesomeIcon icon={['fas', 'calendar-check']} color={'white'}/>
        </span>
        <span className={'label'}>Total Customers Restored</span>
        <span className={'value'}><NumberFormatter>{custR}</NumberFormatter></span>
      </div>
    </div>
);

export default ReportHeader;
